<ng-container *transloco="let t;">
<div>
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center content-sidebar-header py-75 px-1 mt-50">
        <!-- <div class="cursor-pointer" (click)="backToContentSetting()">
            <i data-feather="arrow-left" [size]="16" class="ms-0"></i>
        </div> -->
        <div class="linked-organization-inner">
            <div class="d-flex justify-content-start align-items-center">
                <div class="user-page-info">
                    <h5 class="mb-0">
                        {{t("Content table settings title (Template/Document - section) - Table settings")}}
                    </h5>
                </div>
            </div>
        </div>
        <div class="cursor-pointer closeMenu" (click)="clsoe()">
            <i data-feather="x" [size]="16" class="ms-0"></i>
        </div>
    </div>
</div>
<ng-scrollbar autoHeightDisabled="false" visibility="hover" class="content-tableSetting-scroll">
<div>
    <div class="form-group px-1">
        <label class="col-form-label pt-0">{{t("Content table settings Styles title (Template/Document - section) - Styles")}}</label>

        <div class="d-flex py-25">
            <div class="custom-control custom-checkbox w-50">
                <input type="checkbox" [checked]="header" class="custom-control-input" id="header-option" (change)="toggleHeaderColor($event)" />
                <label class="custom-control-label" for="header-option">{{t("Content table settings Table header label (Template/Document - section) - Header")}}</label>
            </div>
            <div class="custom-control custom-checkbox w-50">
                <input type="checkbox" [checked]="footer" class="custom-control-input" id="footer-option" (change)="toggleFooterColor($event)" />
                <label class="custom-control-label" for="footer-option">{{t("Content table settings Table footer label (Template/Document - section) - Footer")}}</label>
            </div>
        </div>
        <div class="d-flex py-75">
            <div class="custom-control custom-checkbox w-50">
                <input type="checkbox" [checked]="borderRadius" class="custom-control-input" id="border-radius" (change)="toggleBorderRadius($event)" />
                <label class="custom-control-label" for="border-radius">{{t("Content table settings Table border radius label (Template/Document - section) Border radius")}}</label>
            </div>
        </div>
    </div>
    <app-lock-field 
        type="block"
        [uuid]="data['uuid']"
        (lockChange)="onLockChange($event)"
        >
    </app-lock-field>
    <div class="form-group px-1">
        <label class="col-form-label pt-25">{{t("Content table settings Table default Styles label (Template/Document - section) - Default Styles")}}</label>

        <div class="default-style-container">
            <div class="default-style-column" *ngFor="let color of colors; let i = index" [ngClass]="{'active': i === activatedTheme}" (click)="selectTheme(color,i)">
                <div class="default-style-column-layers" [ngStyle]="{'background-color':(color.headerColor)}"></div>
                <div class="default-style-column-layers" [ngStyle]="{'background-color':color.evenColor}"></div>
                <div class="default-style-column-layers" [ngStyle]="{'background-color':color.oddColor}"></div>
                <div class="default-style-column-layers" [ngStyle]="{'background-color':(footer ? color.secondaryFooterColor : color.footerColor)}"></div>
            </div>
        </div>
    </div>

    <div class="form-group px-1">
        <label class="col-form-label pt-25">{{t("Content table settings Table custom Styles label (Template/Document - section) - Custom Styles")}}</label>

        <div class="table-setting-color-box mb-75" *ngIf="header">
            <input class="form-control" [style.background]="headerColor" [value]='t("Content table settings Table header label (Template/Document - section) - Header")' readonly />
            <div class="color-picker-ts-box">
                <div [style.background]="headerColor" [cpOutputFormat]="'rgba'" [(colorPicker)]="headerColor" class="color-picker-ts" (colorPickerSelect)="changeHeaderColor($event)" [cpOKButton]="true" [cpSaveClickOutside]="true"></div>
            </div>
        </div>

        <div class="table-setting-color-box mb-75" *ngIf="header">
            <input style="color: white;" class="form-control" [style.background]="headerTextColor" [value]='t("Content table settings Table header Text color label (Template/Document - section) - Header Text color")' readonly />
            <div class="color-picker-ts-box">
                <div [style.background]="headerTextColor" [cpOutputFormat]="'rgba'" [(colorPicker)]="headerTextColor" class="color-picker-ts" (colorPickerSelect)="changeHeaderTextColor($event)" [cpOKButton]="true" [cpSaveClickOutside]="true"></div>
            </div>
        </div>

        <div class="table-setting-color-box mb-75">
            <input class="form-control" [style.background]="evenColor" [value]='t("Content table settings Table Row color label (Template/Document - section) - Row") + "1"' readonly />
            <div class="color-picker-ts-box">
                <div [style.background]="evenColor" [cpOutputFormat]="'rgba'" [(colorPicker)]="evenColor" class="color-picker-ts" (colorPickerSelect)="changeEvenColor($event)" [cpOKButton]="true" [cpSaveClickOutside]="true"></div>
            </div>
        </div>

        <div class="table-setting-color-box mb-75">
            <input class="form-control" [style.background]="oddColor" [value]='t("Content table settings Table Row color label (Template/Document - section) - Row") + "2"' readonly />
            <div class="color-picker-ts-box">
                <div [style.background]="oddColor" [cpOutputFormat]="'rgba'" [(colorPicker)]="oddColor" class="color-picker-ts" (colorPickerSelect)="changeOddColor($event)" [cpOKButton]="true" [cpSaveClickOutside]="true"></div>
            </div>
        </div>

        <div class="table-setting-color-box mb-75" *ngIf="footer">
            <input class="form-control" [style.background]="footerColor" [value]='t("Content table settings Table footer color label (Template/Document - section) Footer Color")' readonly />
            <div class="color-picker-ts-box">
                <div [style.background]="footerColor" [cpOutputFormat]="'rgba'" [(colorPicker)]="footerColor" class="color-picker-ts" (colorPickerSelect)="changeFooterColor($event)" [cpOKButton]="true" [cpSaveClickOutside]="true"></div>
            </div>
        </div>

        <div class="table-setting-color-box mb-75" *ngIf="footer">
            <input style="color: white;" class="form-control" [style.background]="footerTextColor" [value]='t("Content table settings Table footer Text color label (Template/Document - section) Footer Text color")' readonly />
            <div class="color-picker-ts-box">
                <div [style.background]="footerTextColor" [cpOutputFormat]="'rgba'" [(colorPicker)]="footerTextColor" class="color-picker-ts" (colorPickerSelect)="changeFooterTextColor($event)" [cpOKButton]="true" [cpSaveClickOutside]="true"></div>
            </div>
        </div>

        <div class="table-setting-color-box mb-75">
            <input class="form-control" [style.background]="borderColor" [value]='t("Content table settings Table border Color label (Template/Document - section) - Border Color")' readonly />
            <div class="color-picker-ts-box">
                <div [style.background]="borderColor" [cpOutputFormat]="'rgba'" [(colorPicker)]="borderColor" class="color-picker-ts" (colorPickerSelect)="changeBorderColor($event)" [cpOKButton]="true" [cpSaveClickOutside]="true"></div>
            </div>
        </div>

        <div class="table-setting-color-box mb-75">
            <input style="color: white;" class="form-control" [style.background]="textColor" [value]='t("Content table settings text Color (Template/Document - section) - Text Color")' readonly />
            <div class="color-picker-ts-box">
                <div [style.background]="textColor" [cpOutputFormat]="'rgba'" [(colorPicker)]="textColor" class="color-picker-ts" (colorPickerSelect)="changeTextColor($event)" [cpOKButton]="true" [cpSaveClickOutside]="true"></div>
            </div>
        </div>
    </div>

    <div class="form-group px-1">
        <label class="col-form-label pt-0" for="name">{{t("Content table settings border Style label (Template/Document - section) - Border Style")}}</label>
        <ng-select [items]="borderStyle" bindLabel="name" bindValue="id" [(ngModel)]="selectedBorderStyle" [clearable]="false" (change)="changeBorderStyle($event)">
        </ng-select>
    </div>
    <hr class="mb-2 mt-1" />
    <div class="form-group px-1 mt-1 conditional-dropdown">
        <app-conditional-fields
            [uuid]="data['uuid']"
            [block]="tableBlock"
        ></app-conditional-fields>
    </div>
</div>
</ng-scrollbar>

</ng-container>
